import React from "react";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import shareVideo from "../assets/share.mp4";
import jwtDecode from "jwt-decode";
import { client } from "../utils/client";
import { useNavigate } from "react-router-dom";
import { AiOutlineCamera } from "react-icons/ai";
function Login() {
  const user = false;
  const navigate = useNavigate();
  const googleSignin = (response) => {
    const decodedUser = jwtDecode(response.credential);

    const { name, picture, sub } = decodedUser;
    const user = {
      _id: sub,
      _type: "user",
      userName: name,
      image: picture,
    };
    localStorage.setItem("user", JSON.stringify(decodedUser));

    client.createIfNotExists(user).then(() => {
      navigate("/", { replace: true });
    });
  };
  return (
    <div className=" flex justify-start items-center flex-col h-screen">
      <div className="relative w-full h-full">
        <video
          src={shareVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay">
        <div className="p-5">
          <div className="flex justify-center items-center">
            <AiOutlineCamera fontSize={30} className="text-white" />
            <h1 className="text-xl text-white">ShareThings </h1>
          </div>
          <p className="text-white text-center m-2">
            An application to share photos with the world
          </p>
        </div>
        {user ? (
          <p>Logged In</p>
        ) : (
          <GoogleLogin
            onSuccess={(response) => {
              googleSignin(response);
            }}
            onError={(err) => {
              console.warn(err);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default Login;
